class DynamicsForm extends HTMLElement {
  connectedCallback() {
    this.$formContainer = this.querySelector('[data-form-id]');
    if (!this.$formContainer) return;

    this.courseId = this.$formContainer.dataset.courseId;
    this.brochureUrl = this.$formContainer.dataset.brochureUrl;

    if (!this.courseId && !this.brochureUrl) return;

    this.observer = new MutationObserver(() => this.onFormMutation());
    this.observer.observe(this.$formContainer, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  onFormMutation() {
    const formEl = this.$formContainer.querySelector('form');
    if (!formEl) return;

    this.observer.disconnect();
    DynamicsForm.populateField(formEl, 'bend_mothercode', this.courseId);
    DynamicsForm.populateField(formEl, 'bend_brochureurl', this.brochureUrl);
  }

  static populateField(formEl, targetProperty, value) {
    if (!value) return;

    const input = formEl.querySelector(`[name="${targetProperty}"]`);
    if (!input) return;

    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

customElements.define('dynamics-form', DynamicsForm);
